import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-tabs.css';

var getClassNameList = classNames.bind(styles);
var UitkTabHighlighter = function (props) {
    var style = props.style;
    return React.createElement("li", { "aria-hidden": "true", className: getClassNameList('uitk-tab-highlighter'), style: style });
};
UitkTabHighlighter.displayName = 'UitkTabHighlighter';

export { UitkTabHighlighter };
